import {Spinner} from 'react-bootstrap';

const DotsLoading = ({small = false}: {small?: boolean}) => {
  const smallStyle = {
    width: '0.35rem',
    height: '0.35rem',
  };

  return small ? (
    <div className="d-flex justify-content-center align-items-center">
      <Spinner animation="grow" style={smallStyle} />
      <Spinner animation="grow" style={smallStyle} className="mx-1" />
      <Spinner animation="grow" style={smallStyle} />
    </div>
  ) : (
    <div className="d-flex justify-content-center">
      <Spinner animation="grow" size="sm" />
      <Spinner animation="grow" size="sm" className="mx-2" />
      <Spinner animation="grow" size="sm" />
    </div>
  );
};

export default DotsLoading;
